define(["require", "exports", "tslib", "../services/ServiceTransport"], function (require, exports, tslib_1, ServiceTransport_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MockBase = void 0;
    var MockBase = (function (_super) {
        (0, tslib_1.__extends)(MockBase, _super);
        function MockBase() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.mockList = [];
            return _this;
        }
        MockBase.prototype.inject = function (mock) {
            this.render();
            for (var index = 0; index < this.mockList.length; index++) {
                var element = this.mockList[index];
                mock.mock("".concat(this.options.baseUrl).concat(element.url), element.method, element.responseData);
                console.log("\u68C0\u6D4B\u5230MOCK\u914D\u7F6E:: \u63A5\u53E3 ".concat(element.url, "  \u65B9\u6CD5: ").concat(element.method, " \u5C06\u4F7F\u7528\u6A21\u62DF\u6570\u636E\u8FD4\u56DE."));
            }
        };
        MockBase.prototype.render = function () {
        };
        MockBase.GET = 'get';
        MockBase.POST = 'post';
        return MockBase;
    }(ServiceTransport_1.ServiceTransport));
    exports.MockBase = MockBase;
});
//# sourceMappingURL=MockBase.js.map